// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"M_cZ","slider__element":"M_c0","itemSlider":"M_c1","itemSlider__slideWrapper":"M_c2","itemSlider__pagination":"M_c3","activeSlide":"M_c4"};